import {dataTestId, HPButton, TextOnBackground} from '@hconnect/uikit'
import {Add} from '@mui/icons-material'
import {Box, Stack} from '@mui/material'
import React from 'react'
import {useTranslation} from 'react-i18next'

import NoTargetsIcon from '../../../../../assets/images/targets.svg'

interface StrengthTargetEmptyStateProps {
  onNewTarget: () => void
  isReadOnly: boolean
}

export const StrengthTargetEmptyState: React.FC<StrengthTargetEmptyStateProps> = ({
  onNewTarget,
  isReadOnly
}) => {
  const {t} = useTranslation()

  return (
    <Stack
      spacing={3}
      alignItems="center"
      justifyContent="center"
      sx={{
        py: 8,
        px: 4
      }}
      {...dataTestId('strength_target_empty_state')}
    >
      <Stack
        alignItems="center"
        justifyContent="center"
        sx={{
          width: 240,
          height: 240,
          mb: 2
        }}
        {...dataTestId('empty_state_illustration')}
      >
        <Box
          component="img"
          src={NoTargetsIcon}
          alt={t('materialsSettings.strengthTargets.noTargetsYet')}
          sx={{
            width: '100%',
            height: '100%',
            objectFit: 'contain'
          }}
          {...dataTestId('no_targets_icon')}
        />
      </Stack>

      <TextOnBackground
        variant="h6"
        sx={{
          fontWeight: 600,
          color: (theme) => theme.palette.text.primary
        }}
        {...dataTestId('empty_state_title')}
      >
        {t('materialsSettings.strengthTargets.noTargetsYet')}
      </TextOnBackground>

      {!isReadOnly && (
        <>
          <TextOnBackground
            variant="body2"
            sx={{
              color: (theme) => theme.palette.text.secondary,
              textAlign: 'center'
            }}
            {...dataTestId('empty_state_description')}
          >
            {t('materialsSettings.strengthTargets.clickButtonToCreateTarget')}
          </TextOnBackground>

          <HPButton
            variant="text"
            startIcon={<Add />}
            onClick={onNewTarget}
            sx={{
              textTransform: 'none',
              fontSize: '14px',
              fontWeight: 500
            }}
            {...dataTestId('new_target_button')}
          >
            {t('materialsSettings.strengthTargets.newTarget')}
          </HPButton>
        </>
      )}
    </Stack>
  )
}
